import React from 'react';
import Drawer from "components/Drawers/Drawer";
import { actionsType } from 'config/constants';
import RegisterPrime from './RegisterPrime';
import style from './style.scss'


const DrawerRegisterPrime = () => {


    return(
        <Drawer customClass={'drawer-register-prime'} actionOpen={actionsType.DRAWER.REGISTER_PRIME_OPEN} actionClose={actionsType.DRAWER.REGISTER_PRIME_CLOSE}>
            <RegisterPrime />
        </Drawer>
    )
}

export default DrawerRegisterPrime;